<template>
  <p
    v-html="$t('pin.countdown', { sec: requestTimer.remaining })"
    class="countdown"
    :class="requestTimer.remaining < 10 ? 'warnning' : ''"
    v-if="!stopTimer"
  />
</template>

<script>
export default {
  props: {
    expiration: {
      type: Number,
      default: 0,
    },
    stopTimer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      requestTimer: {
        remaining: 0,
        count: "",
      },
    };
  },
  watch: {
    stopTimer: {
      deep: true,
      handler: function (newVal) {
        if (newVal == false) return;
        clearTimeout(this.requestTimer.count);
      },
    },
  },
  mounted() {
    this.requestTimer.remaining =
      this.expiration - Math.floor(Date.now() / 1000);
    this.requestTimer.count = setInterval(this.requestCount, 1000);
  },
  unmounted() {
    clearTimeout(this.requestTimer.count);
  },
  methods: {
    requestCount() {
      if (this.requestTimer.remaining > 0) {
        this.requestTimer.remaining =
          this.expiration - Math.floor(Date.now() / 1000);
      } else {
        clearTimeout(this.requestTimer.count);
        this.$emit("expired");
      }
    },
  },
};
</script>